<div class="page-root">
  <div class="page-one-column-body">
    <div class="page-column">
      <app-logo/>
      <div class="typo-h1">{{ "booking.success.title" | transloco }}</div>
      <div class="body-text">{{ "booking.success.description" | transloco }}</div>

      <div class="actions">
        <app-text-button (click)="bookAppointment()" [text]="'booking.success.button.bookAppointment' | transloco" colorVariant="primary" leadingIcon="calendar_month" type="rounded"/>
        <app-text-button (click)="manageAppointments()" [text]="'booking.success.button.manageAppointments' | transloco" colorVariant="secondary" leadingIcon="edit_calendar" type="rounded"/>
      </div>
    </div>
  </div>
</div>
